export default __webpack_public_path__ + "static/media/page1-img_03.f34ac215.jpg";